import { parsePhoneNumber } from 'react-phone-number-input'
import { padEnd } from 'lodash'

export function defineCountryByPhonePrefix(phone: string) {
  // Library requires 12 symbols and no brackets
  const cleanedPhone = padEnd(
    phone.replaceAll('(', '').replaceAll(')', ''),
    12,
    '0'
  )
  const parsedPhone = parsePhoneNumber(cleanedPhone)
  return parsedPhone?.country
}
